import { DocumentNode, gql } from "@apollo/client";

class KitService {
  public static addKit = (): DocumentNode => gql`
    mutation placeKitOrder(
      $orderUidPublic: String!
      $testUid: String!
      $address: AddressOptional!
      $token: String
      $isPublicMpFlow: Boolean
    ) {
      placeKitOrder(
        orderUidPublic: $orderUidPublic
        testUid: $testUid
        address: $address
        token: $token
        isPublicMpFlow: $isPublicMpFlow
      ) {
        result
        kitOrderSkippedForPR
      }
    }
  `;
}

export default KitService;
